import { SVGProps } from 'react';

const HandPlatter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3V2m7 8a7 7 0 1 0-14 0m10.4 7.4 3.2-2.8a2.015 2.015 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5m-3-5h12a2 2 0 0 1 0 4h-2m-8-8h16M5 14v6a1 1 0 0 1-1 1H2"
    />
  </svg>
);
export default HandPlatter;
